/* istanbul ignore file */
/* tslint:disable */
 

/**
 * * `gasoline` - Benzină
 * * `diesel` - Diesel
 * * `hybrid` - Hibrid
 * * `electric` - Electric
 * * `lpg` - GPL
 * * `cng` - CNG (Metan)
 */
export enum FuelTypeEnum {
  GASOLINE = 'gasoline',
  DIESEL = 'diesel',
  HYBRID = 'hybrid',
  ELECTRIC = 'electric',
  LPG = 'lpg',
  CNG = 'cng',
}
